export const IS_PRODUCTION = true;
export const IS_PRINT_LOG = true;


/**
 * API_CONFING, Base host and api access key
 */
export const API_CONFIG = {
  API_HOST: getApiHost(),
  ACCESS_KEY: "A31AB78E-C4C7-4C9E-AD98-6D6A1B801E45",
};

/**
 * Requst Headers
 */
export const API_HEADERS = {
  "Content-Type": "application/json",
  "api-access-key": API_CONFIG.ACCESS_KEY,
};

function getApiHost() {
  // Products and nutrition must use the same server (and database), or a product id
  // made on one names a different product on the other. Set REACT_APP_API_HOST to it.
  if (process.env.REACT_APP_API_HOST) return process.env.REACT_APP_API_HOST;
  return IS_PRODUCTION
    ? "https://testapi.eatprotein.in/"
    : "https://cms.eatprotein.in/";
}

/**
 * New EatProtein platform services (NestJS). Nutrition labels and health
 * grades live here; everything else still uses API_HOST above.
 * Override per environment in .env: REACT_APP_IDENTITY_API / REACT_APP_NUTRITION_API /
 * REACT_APP_COMMERCE_API, and REACT_APP_SHOP_STORE_ID for the shop's default store.
 *
 * REACT_APP_NUTRITION_BACKEND=php uses the nutrition routes of the PHP API
 * instead (REACT_APP_NUTRITION_API=https://api.eatprotein.in/): sign-in goes to
 * its nutrition/auth/login and no identity service is needed.
 */
export const PLATFORM_CONFIG = {
  IDENTITY_API: process.env.REACT_APP_IDENTITY_API || "http://localhost:3001/api/",
  COMMERCE_API: process.env.REACT_APP_COMMERCE_API || "http://localhost:3002/api/",
  NUTRITION_API: process.env.REACT_APP_NUTRITION_API || "http://localhost:3003/api/",
  NUTRITION_BACKEND: process.env.REACT_APP_NUTRITION_BACKEND || "platform",
  SHOP_STORE_ID: Number(process.env.REACT_APP_SHOP_STORE_ID) || null,
};
